/** Compatibility re-export for the workflow bundled by the recap CLI package. */
export { PR_VISUAL_RECAP_WORKFLOW_YML } from "@agent-native/recap-cli";
